import * as React from 'react';
import { getIsWhiteLabel } from '@/redux/modules/whiteLabel';
import { useAppSelector } from '@/redux/hooks';
import LAFooter from './LAFooter/LAFooter';
import WhiteLabelFooter from './WhiteLabelFooter/WhiteLabelFooter';

const Footer = () => {
    const whiteLabel = useAppSelector(getIsWhiteLabel);
    return whiteLabel ? <WhiteLabelFooter /> : <LAFooter />;
};

// because whitelabel will never update we can keep memo
export default React.memo(Footer);
